module.exports = __webpack_public_path__ + "img/wilke-logo.3a1aecec.svg";